export default __webpack_public_path__ + "static/media/Cynopsis.bc55c7b7.png";